import { Fragment, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import Drawer from "src/Components/Custom/Drawer/Drawer";
import UserNavBar from "src/Components/Custom/UserNavBar/UserNavBar";
import EndPoints from "src/Constants/EndPoints";
import useStateCity from "src/Hooks/Custom/useStateCity";
import useApiFetch from "src/Hooks/Shared/useApiFetch";
import AppStateHandler, {
  useAppState,
} from "src/StateHandlers/AppStateHandler";
import EditProfileModal from "./Components/EditProfileModal";
import { useTranslation } from "react-i18next";

function Profile() {
  const { t, i18n } = useTranslation();
  const [{ showSidebar }] = useAppState();
  const { user } = AppStateHandler.getState();
  const { data: profileResponse, refetch: refetchProfile } = useApiFetch(
    [EndPoints.editProfile + "?subId=" + user.username],
    {}
  );
  const profileData = profileResponse?.data?.Items?.[0] ?? user.attributes;
  const {
    name = "",
    family_name = "",
    phone_number = "",
    email = "",
    picture,
    state_name,
    city_name,
  } = profileData;
  const [modalVisibility, setModalVisibility] = useState<boolean>(false);
  const { control, errors, handleSubmit, watch, register, setValue, reset } = useForm({
    defaultValues: {
      name: name,
      family_name: family_name,
      phone_number: phone_number,
      state_id: user.attributes['custom:state_id'],
      city_id: user.attributes['custom:city_id'],
    },
    mode: "onChange",
  });

  const { stateData, cityData } = useStateCity(watch("state_id"));
  const _state_id = watch("state_id");
  useEffect(() => {
    if (_state_id) {
      setValue("city_id", "");
    }
  }, [setValue, _state_id]);

  return (
    <Fragment>
      <div className={showSidebar ? "" : "toggle_class"}>
        <UserNavBar />
        <div className="wrapper">
          <Drawer />
          <div id="content" className={`${i18n.dir() === 'rtl'?'rtl-content-padding':'ltr-content-padding'}`}>
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-9">
                  <div
                    className="col_selector bg-white px-2 px-sm-4 py-4 post_feed"
                    style={{ borderRadius: "9px" }}
                  >
                    <div className="mb-4">
                      <div className="d-flex flex-column align-items-center position-relative">
                        <i
                          className="fa fa-pencil position-absolute profile_pencil cursor-pointer"
                          onClick={() => setModalVisibility(true)}
                        ></i>
                        <div className="mb-3 position-relative">
                          <img
                            src={
                              picture !== ""
                                ? picture
                                : "assets/images/profile-camera.png"
                            }
                            width="150"
                            height="150"
                            className="rounded-circle object_fit"
                            alt=""
                          />
                        </div>
                        <div className="text-center">
                          <p className={`fz14  mb-0 text-secondary ${i18n.dir() === "rtl" ? "Almaraisemibold" : "poppinsregular"}`}>
                            {t('Personal Info')}:
                          </p>
                          <h3 className={`fz22 poppinsbold mb-0}`}>
                            {name} {family_name}
                          </h3>
                          <span className="poppinsbold base_color">
                            {state_name}, {city_name}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group row fz15 poppinsregular">
                          <label className={`col-sm-5  ${i18n.dir() === "rtl" ? "Almaraisemibold" : "poppinsregular"}`}>{t('Phone')}</label>
                          <div className="col-sm-7">
                            <p className="text-sm-right">{phone_number}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group row fz15 poppinsregular">
                          <label className={`col-sm-5  ${i18n.dir() === "rtl" ? "Almaraisemibold" : "poppinsregular"}`}>{t('Email')}</label>
                          <div className="col-sm-7">
                            <p className="text-sm-right">{email}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group row fz15 poppinsregular">
                          <label className={`col-sm-5  ${i18n.dir() === "rtl" ? "Almaraisemibold" : "poppinsregular"}`}>{t('Neighborhood')}</label>
                          <div className="col-sm-7">
                            <p className="text-sm-right">
                              {state_name}, {city_name}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modalVisibility ? (
        <EditProfileModal
          setModalVisibility={setModalVisibility}
          showModal={modalVisibility}
          profileData={profileData}
          control={control}
          errors={errors}
          watch={watch}
          setValue={setValue}
          handleSubmit={handleSubmit}
          refetchProfile={refetchProfile}
          register={register}
          reset={reset}
          stateData={stateData}
          cityData={cityData}
        />
      ) : (
          <Fragment />
        )}
    </Fragment>
  );
}

export default Profile;
